const acl = {
    en: {
      acl: {
        title: {
          rename: "Rename Security Group",
          create: "Create Security Group"
        },
        set_name: "Create",
        rename: "Rename",
        actions: {
          acl_manage: "Manage Access Control List",
          acl_view: "See Access Control List",
          carma_ai_manage: "Manage Carma AI",
          carma_ai_codings: "Manage AI codings",
          carma_ai_view_client_dashboard_stories: "View Client Dashboard Stories",
          carma_ai_manage_client_dashboard_stories: "Manage Client Dashboard Stories",
          carma_ai_manage_geo_dashboard: "Manage AI Visibility Dashboard",
          carma_ai_manage_storyboards: "Manage Storyboards",
          outlets_import: "Import outlets",
          outlets_manage: "Manage outlets",
          outlets_currency_conversions: "Manage currency conversion",
          outlet_statistics_import: "Import statistics",
          outlet_statistics_manage: "Manage statistics",
          projects_create_commercial: 'Create a commercial project',
          projects_create_marketing: 'Create a marketing project',
          projects_manage_provider_limits: "Manage provider limits",
          users_manage: 'Manage users',
          users_view: 'See other users',
          insight_users_login_as: 'Login to Insight as a user',
          real_time_alerts_manage_whatsapp_contacts: 'Manage WhatsApp contacts',
          real_time_alerts_manage_mobile_app_contacts: 'Manage Mobile App contacts',
          client_data_api_view: 'View Client Data API',
          client_data_api_manage: 'Manage Client Data API'
        },
        teams: {
          name: "Name"
        },
        groups: {
          acl: 'Access Permissions (this page)',
          carma_ai: 'AI',
          outlets: 'Outlets',
          outlet_statistics: 'Outlet Statistics',
          projects: 'Projects',
          users: 'Users',
          insight_users: 'Insight Users',
          real_time_alerts: 'Real Time Alerts',
          client_data_api: 'Client Data API'
        },
        request: {
          forbidden: "You don't have sufficient permissions to access this resource",
          unauthorized: "You're not authorized, please login again"
        },
        delete: "Delete Security Group",
        save: "Save",
        create_team: "Create Security Group",
        rename_team: "Rename Security Group",
        delete_team: "Delete Security Group",
        cancelCreateTeam: "Cancel Creation",
        cancelRenaming: "Cancel Renaming",
        security_group: "Security Group",
        tooltips: {
          acl_manage: "Allow to manage Access Control List: change permission of security groups",
          acl_view: "See Access Control List: you can view this page, but actions on it are disabled",
          carma_ai_manage: "This allow to see and manage AI pages to tune prompt for Filtration, Summary, ...",
          carma_ai_codings: "Allow to manage AI coding rules and auto-coder configuration",
          carma_ai_view_client_dashboard_stories: "Allow read-only access to Client Dashboard Stories (project picker and wizard viewing)",
          carma_ai_manage_client_dashboard_stories: "Allow full edit access to Client Dashboard Stories (generate, publish, discard, and related changes)",
          carma_ai_manage_geo_dashboard: "Allow access to AI Visibility Dashboard: create, edit, run, and view AI Visibility monitors",
          carma_ai_manage_storyboards: "Allow setting up Insight storyboards (builder)",
          outlets_import: "Allow to batch-import outlets",
          outlets_manage: "Allow to manage outlets",
          outlet_statistics_import: "Allow to batch-import outlet statistics (similarweb)",
          outlet_statistics_manage: "Allow to manage outlet statistics (similarweb)",
          projects_create_commercial: 'Allow to create new commercial projects',
          projects_create_marketing: 'Allow to create new marketing projects',
          projects_manage_provider_limits: 'Allow user to change the provider limits setup for each project',
          users_manage: 'Manage users, change their name, emails, ...',
          users_view: 'Consult other\'s user profile',
          insight_users_login_as: 'Allow to open an Insight client account from Bodhi. The verification code is emailed to whoever clicks, not to the client',
          real_time_alerts_manage_whatsapp_contacts: 'Manage WhatsApp Contacts and Contact List',
          real_time_alerts_manage_mobile_app_contacts: 'Manage Mobile App Contacts and Contact List',
          client_data_api_view: 'See the Client Data API page and its tab in Coding',
          client_data_api_manage: 'Turn the Client Data API on or off for a project, and generate or revoke keys'
        }
      }
    }
  };
  
  module.exports.acl = acl;
